export const appVersion = '1.0.3';
export const iosVersion = '1.0.6(44)';
export const androidVersion = '1.0.2(45)';